import { UpcomingPaymentDto } from '../../../models/dtos/upcoming-payment.dto';

export const mockUpcomingPayment: UpcomingPaymentDto = {
  payment_number: 1,
  date_due: '2025-07-15T00:00:00Z',
  payment_amount: 250.75,
};
